module.exports = __webpack_public_path__ + "img/4.ef8c143b.jpg";